import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { API, arrToMap, fetchMenu, setError } from '.'


export const fetchCart = createAsyncThunk('cart/fetchCart', async (itemsToLoad, thunkAPI) => {
   thunkAPI.dispatch(fetchMenu())
   if (itemsToLoad.length === 0) return thunkAPI.fulfillWithValue([])
   try {
      const response = await API.get(`/cardsSlice`, { params: { type: 'id', value: itemsToLoad.join('_') } })
      return response.data
   } catch (err) {
      thunkAPI.dispatch(setError({ action: 'fetchCart', code: err.response.status, message: err.message }))
      return thunkAPI.rejectWithValue()
   }
})

const initialState = {
   items: {},
   entities: {},
   status: 'init'
}

const cartSlice = createSlice({
   name: 'cart',
   initialState,
   reducers: {
      changeCartItemCount(state, action) {
         const { id, count } = action.payload
         state.items[id] = count
      },
      removeCartItem(state, action) {
         delete state.items[action.payload]
         delete state.entities[action.payload]
      },
      clearCart(state) {
         state.items = {}
         state.entities = {}
      }
   },
   extraReducers: builder => {
      builder.addCase(fetchCart.pending, state => {
         state.status = 'loading'
      })
      builder.addCase(fetchCart.fulfilled, (state, action) => {
         Object.assign(state.entities, arrToMap(action.payload))
         state.status = 'success'
      })
      builder.addCase(fetchCart.rejected, state => {
         state.status = 'error'
      })
   }
})

export const cart = cartSlice.reducer
export const { changeCartItemCount, removeCartItem, clearCart } = cartSlice.actions
